export default "__VITE_ASSET__MAPFt41a__"